import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import useToastDismiss from './utils/hooks/useToastDismiss';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { OnboardingProvider } from './contexts/OnboardingContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

import Onboarding from './pages/Onboarding';
import { GraphQLClientProvider } from './contexts/GraphQLClientContext ';
import { useAxiosClient } from './contexts/GraphQLClientContext ';
import NotFound from './pages/NotFound';
import Wrapper from './pages/Success';

// Create a wrapper component to handle location and prop changes
const RouteWrapper = ({ children }) => {
  useToastDismiss();
  return children;
};

function App() {
  const location = useLocation();
  const isSuccessRoute = location.pathname === '/onboarding/success';

  return (
    <RouteWrapper>
      <Routes>
        <Route
          path="/onboarding/success"
          element={
            <OnboardingProvider>
              <Wrapper />
            </OnboardingProvider>
          }
        />
      </Routes>
      {!isSuccessRoute && (
        <AuthProvider>
          <Routes>
            {/* Public routes that redirect to onboarding if authenticated */}

            {/* Protected routes */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingRouter />
                </ProtectedRoute>
              }
            />

            {/* Other routes */}
            <Route path="/*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/onboarding" />} />
          </Routes>
          <ToastContainer />
        </AuthProvider>
      )}
    </RouteWrapper>
  );
}

// Router component to handle onboarding screens
function OnboardingRouter() {
  const location = useLocation();
  const screen = location.state?.screen;
  const client = useAxiosClient();

  switch (screen) {
    default:
      return (
        <GraphQLClientProvider value={client}>
          <OnboardingProvider>
            <Onboarding />
          </OnboardingProvider>
        </GraphQLClientProvider>
      );
  }
}

export default App;
